/*eslint-disable */
import createSubscriptionProduct from '../create-plan';
import planStatusPopup from '../plan-status-popup';
import planClearPopup from '../plan-clear-popup';
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
export default {
  name: 'plan-list',
  components: {
    'subscription-product' : createSubscriptionProduct,
    'plan-status' : planStatusPopup,
    'plan-clear' : planClearPopup
  },
  props: [],
  data () {
    return {
      subscriptionPlanInfo:null,
      subscriptionPlanInfoResults:[],
      createSubscriptionProductState:false,
      planStatusChangeState:false,
      planId:'',
      planStatus:'',
      allPlanClearState:false
    }
  },
  computed: {
    ...mapGetters([
      'getSubscriptionPlanListGetters'
    ]),
    getSubscriptionPlanListInfo(){
      this.subscriptionPlanInfo = this.$store.getters.getSubscriptionPlanListGetters;
      return
    },
    setInitialStateOfProduct(){
      if(this.subscriptionPlanInfo){
        this.subscriptionPlanInfoResults = this.subscriptionPlanInfo.data
      }
      return;
    }
  },
  mounted () {
    this.getSubscriptionPlanListInfo
    this.setInitialStateOfProduct
    bus.$on('createSubscriptionProductStateBus', (data) => {
      this.createSubscriptionProductState = data;
    });
    bus.$on('planStatusChangeStateBus', (data) => {
      this.planStatusChangeState = data;
    });
    bus.$on('allPlanClearStateBus', (data) => {
      this.allPlanClearState = data;
    });
  },
  methods: {
    allPlanClearStatePopupOpen(){
      this.allPlanClearState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    planStatusChangeStatePopupOpen(id, status){
      this.planStatus = status
      this.planId = id
      this.planStatusChangeState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    createSubscriptionProductPopupOpen(){
      this.createSubscriptionProductState = true
      document.body.classList.add('body_right_scroll_remove')
    }
  },
  watch:{
    getSubscriptionPlanListInfo(){
      return this.$store.getters.getSubscriptionPlanListGetters
    },
    setInitialStateOfProduct(){
      if(this.subscriptionPlanInfo){
        this.subscriptionPlanInfoResults = this.subscriptionPlanInfo.data
      }
      return;
    }
  }
}